import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./NavBar.css";
import Button from "../Button/Button";
import images from "../../Utils/Images/index.jsx";
import BookBtn from "../BookBtn/BookBtn";
import TechIcon from "../../Utils/Icons/Icons.jsx";
import posthog from "posthog-js";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    const open = !menuOpen;
    setMenuOpen(open);

    if (open) document.body.classList.add("noScroll");
    else document.body.classList.remove("noScroll");
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.classList.remove("noScroll");
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const showBookDemoBtn = posthog.isFeatureEnabled("bookDemo_btn");
  
  return (
    <>
      <motion.nav
        className="navBar"
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <NavLink to="/" className="navLogo" onClick={closeMenu}>
          <img src={images.logo} alt="Logo" />
          Softations
        </NavLink>

        <div className="navBtns">
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "navBtn1 navActive" : "navBtn1"
            }
          >
            Get in touch
          </NavLink>

          {showBookDemoBtn && (
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                isActive ? "navBtn2 navActive" : "navBtn2"
              }
            >
              Book Demo
            </NavLink>
          )}

          <BookBtn />
        </div>

        <div className="navHamburger" onClick={toggleMenu}>
          {menuOpen ? <TechIcon name="x" /> : <TechIcon name="menu" />}
        </div>
      </motion.nav>

      <div className={`navMobMenu ${menuOpen ? "open" : ""}`}>
        <div className="navMobHead">
          <NavLink to="/" className="navMobLogo" onClick={closeMenu}>
            <img src={images.logo} alt="Logo" />
            <span>Softations</span>
          </NavLink>

          <div className="navMobClose" onClick={toggleMenu}>
            <TechIcon name="x" />
          </div>
        </div>

        <div className="navMobGrid">
          <ul>
            <li>
              <NavLink to="/aboutUs" onClick={closeMenu}>
                About us
              </NavLink>
            </li>
            <li>
              <NavLink to="/careers" onClick={closeMenu}>
                Careers
              </NavLink>
            </li>
            <li>
              <NavLink to="/membership" onClick={closeMenu}>
                Membership
              </NavLink>
            </li>
            <li>
              <NavLink to="/locations" onClick={closeMenu}>
                Locations
              </NavLink>
            </li>
          </ul>

          <ul>
            <li>
              <NavLink to="/terms" onClick={closeMenu}>
                Terms
              </NavLink>
            </li>
            <li>
              <NavLink to="/faqs" onClick={closeMenu}>
                FAQ's
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" onClick={closeMenu}>
                Contact Us
              </NavLink>
            </li>
            <li>
              <NavLink to="/aboutUs" onClick={closeMenu}>
                About Us
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="navMobBtns">
          <Button className="navMobBtn1">
            <NavLink to="/contact" onClick={closeMenu}>
              Get in touch
            </NavLink>
          </Button>

          {showBookDemoBtn && (
            <Button className="navMobBtn2">
              <NavLink to="/pricing" onClick={closeMenu}>
                Book Demo
              </NavLink>
            </Button>
          )}

          <BookBtn />
        </div>
      </div>
    </>
  );
};

export default Navbar;
